import type {FC} from 'react';
import {observer} from 'mobx-react';
import {Box, Button, Icon, IconNames} from '@wellstone-solutions/web';
import type {UIResourceType} from '@wellstone-solutions/common/models/rest';
import {useStores} from 'hooks/useStores';
import {FlagSent} from '../FlagSent';

interface FlagResourceButtonProps {
  resource: UIResourceType;
  onFlag: () => void;
}

export const FlagResourceButton: FC<FlagResourceButtonProps> = observer(
  ({resource, onFlag}) => {
    const {resourceStoreV2} = useStores();

    if (resourceStoreV2.isResourceFlagged(resource)) {
      return (
        <Box component="span" sx={styles.flagSent}>
          <FlagSent resource={resource} />
        </Box>
      );
    }

    return (
      <Button
        data-testid="flag-resource-button"
        onClick={onFlag}
        sx={styles.button}
        startIcon={
          <Icon name={IconNames.TriangleFlag} size={16} color="primary" />
        }>
        Flag
      </Button>
    );
  },
);

const styles = {
  button: {
    textTransform: 'none',
    '& .MuiButton-startIcon': {
      marginRight: 0.75,
      marginLeft: 0,
    },
  },
  flagSent: {ml: 1, display: 'inline-flex', verticalAlign: 'middle'},
};
